import { render } from "./ProjectsListView.vue?vue&type=template&id=76740ed0&scoped=true&ts=true"
import script from "./ProjectsListView.vue?vue&type=script&lang=ts"
export * from "./ProjectsListView.vue?vue&type=script&lang=ts"

import "./ProjectsListView.vue?vue&type=style&index=0&id=76740ed0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76740ed0"]])

export default __exports__